import { StyleSheet } from 'react-native';
import colors from '@/config/colors';
import theme from '@/config/theme';
import { IS_ANDROID } from '@/utils/platform';

export const styles = StyleSheet.create({
  heading: {
    fontSize: theme.fontSizes.base,
    fontWeight: '600',
    fontFamily: 'InterSemiBold',
    color: colors.newUI.therapist.textBlue100,
    marginBottom: theme.spacings.sm,
  },
  description: {
    fontSize: theme.fontSizes.sm,
    fontWeight: '400',
    color: colors.newUI.therapist.textBlue100,
    marginBottom: theme.spacings.sm,
  },
  content: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginTop: theme.spacings.sm,
  },
  selectedColorWrapper: {
    height: 120,
    width: 120,
    borderRadius: 100,
    borderWidth: 2,
    alignItems: 'center',
    justifyContent: 'center',
  },
  picker: {
    flexGrow: 1,
    flexBasis: 240,
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 12,
    maxWidth: '70%',
  },
  color: {
    width: 62,
    height: 62,
    borderRadius: 100,
    alignItems: 'center',
    justifyContent: 'center',
  },
  profileInitials: {
    fontSize: 40,
    textAlign: 'center',
    letterSpacing: 10,
    marginRight: IS_ANDROID ? 0 : -10,
    includeFontPadding: false,
  },
});
